import React, { useState } from "react";
import {
  CardOne,
  CardThree,
  CardTwo,
  Cards,
  Cardsdiv,
  Check,
  Container,
  Header,
  HeaderText,
  IconArea,
  IconFour,
  IconOne,
  IconThree,
  IconTwo,
  IconeExit,
  Mini,
  MiniTitle,
  Text,
  TextArea,
} from "./style";
import "./style.css";
import Input from "../../Components/Input";
import CadastroManual from "../../Components/modals/CadastroManual";
import CadastroImport from "../../Components/modals/CadastroImport";
import { useNavigate } from "react-router-dom";
import CadastroPhoto from "../../Components/modals/CadastroPhotos";
import CadastroCurso from "../../Components/modals/CadastroCurso";

export default function CadastroAluno() {
  const Navigate = useNavigate();
  const [Show, setShow] = useState(false);
  const [ShowCreateCurso, setShowCreateCurso] = useState(false);
  const [ShowImport, setShowImport] = useState(false);
  const [ShowPhoto, setShowPhoto] = useState(false);

  return (
    <Container>
      <CadastroManual Show={Show} setShow={setShow} />
      <CadastroCurso Show={ShowCreateCurso} setShow={setShowCreateCurso} />
      <CadastroImport Show={ShowImport} setShow={setShowImport} />
      <CadastroPhoto setShowPhoto={setShowPhoto} ShowPhoto={ShowPhoto} />
      <br />
      <Header>
        <IconeExit
          onClick={() => {
            Navigate("/visualizaralunos");
          }}
        />
      </Header>
      <Cards>
        <Cardsdiv>
          <CardOne onClick={() => setShow(true)}>
            <Check>
              <input className="CheckOne" type={"checkbox"} />
            </Check>
            <IconArea>
              <IconOne />
            </IconArea>
            <MiniTitle>
              <Mini>Cadastro Aluno Manual</Mini>
            </MiniTitle>
            <TextArea>
              <Text>Inclusão de um aluno por vez preenchendo suas credenciais para o cadastro correto.</Text>
            </TextArea>
          </CardOne>
          <CardOne onClick={() => setShowCreateCurso(true)}>
            <Check>
              <input className="CheckOne" type={"checkbox"} />
            </Check>
            <IconArea>
              <IconFour />
            </IconArea>
            <MiniTitle>
              <Mini>Cadastrar Curso</Mini>
            </MiniTitle>
            <TextArea>
              <Text>Inclusão de um curso por vez preenchendo as credenciais para o cadastro correto.</Text>
            </TextArea>
          </CardOne>
          <CardTwo onClick={() => setShowImport(true)}>
            <Check>
              <input className="CheckTwo" type={"checkbox"} />
            </Check>
            <IconArea>
              <IconTwo />
            </IconArea>
            <MiniTitle>
              <Mini>Importação de Alunos</Mini>
            </MiniTitle>
            <TextArea>
              <Text>Inclusão de um lista de alunos a partir de um arquivo XLSX. </Text>
            </TextArea>
          </CardTwo>
          <CardThree onClick={() => setShowPhoto(true)}>
            <Check>
              <input className="CheckThree" type={"checkbox"} />
            </Check>
            <IconArea>
              <IconThree />
            </IconArea>
            <MiniTitle>
              <Mini>Importação de Fotos</Mini>
            </MiniTitle>
            <TextArea>
              <Text>Carregar as fotos dos alunos.</Text>
            </TextArea>
          </CardThree>
        </Cardsdiv>
      </Cards>
    </Container>
  );
}
